import React, { Component } from "react";
import { injectIntl, defineMessages, FormattedMessage } from "react-intl";

import Reassurance from "theme/components/organisms/Reassurance";
import FormItem from "theme/components/molecules/Form/Item";
import FormActions from "theme/components/molecules/Form/FormActions";
import { SuccessAlert } from "theme/components/molecules/Alert";
import Divider from "theme/components/atoms/Layout/Divider";
import Button from "theme/components/atoms/Button";
import { ButtonLink } from "theme/components/atoms/Typography/Link";
import Fieldset from "theme/components/atoms/Form/Fieldset";
import Form from "theme/components/atoms/Form/Form";
import { Email } from "theme/components/atoms/Form/Input";
import { H5 } from "theme/components/atoms/Typography/Heading";
import InitiatePasswordReset from "./InitiatePasswordReset.gql";
import EnhancePasswordRequest from "./EnhancePasswordRequest";
import ResizedImage from "theme/components/atoms/ResizedImage";
import PasswordRequestConfigurationQuery from "./PasswordRequestConfigurationQuery.gql";

const messages = defineMessages({
  label: {
    id: "pages.PasswordManagment.PasswordRequest.label",
    defaultMessage: "Email",
  },
  placeholder: {
    id: "pages.PasswordManagment.PasswordRequest.placeholder",
    defaultMessage: "me@example.com",
  },
  submit: {
    id: "pages.PasswordManagment.PasswordRequest.submit",
    defaultMessage: "Request a new password",
  },
  feedback: {
    id: "pages.PasswordManagment.PasswordRequest.feedback",
    defaultMessage:
      "An email has just been sent to you! Please check your email address",
  },
  backLogin: {
    id: "pages.PasswordManagment.PasswordRequest.backLogin",
    defaultMessage: "Back to identification",
  },
  back: {
    id: "pages.PasswordManagment.PasswordRequest.back",
    defaultMessage: "Return to the site",
  },
});

class PasswordRequest extends Component {
  constructor() {
    super();

    this.state = {
      allowSubmit: false,
    };

    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
  }

  enableButton() {
    this.setState((state) => ({
      allowSubmit: true,
    }));
  }

  disableButton() {
    this.setState((state) => ({
      allowSubmit: false,
    }));
  }

  render() {
    const { intl } = this.props;
    return (
      <React.Fragment>
        <div className="account-form--register account-form--password-request">
          <div className="account-form--register__wrapper">
            <div className="account-form--register__connection">
              <div className="account-form--register__connection__title account-form--register__connection__title--login">
                <H5 as="h2">
                  <FormattedMessage
                    id="pages.PasswordManagment.PasswordRequest.title"
                    defaultMessage="Forgotten password"
                  />
                </H5>
              </div>
              <div className="account-form--register__connection__form">
                {!this.props.commandResponse && (
                  <p>
                    <FormattedMessage
                      id="pages.PasswordManagment.PasswordRequest.description"
                      defaultMessage="Forgotten password"
                    />
                  </p>
                )}

                <Form
                  onSubmit={this.props.initiatePasswordReset}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                >
                  <Fieldset>
                    {this.props.commandResponse &&
                    !this.props.commandPending ? (
                      <SuccessAlert>
                        {intl.formatMessage(messages.feedback)}
                      </SuccessAlert>
                    ) : (
                      <FormItem label={intl.formatMessage(messages.label)}>
                        <Email
                          name="email"
                          id="email"
                          placeholder={intl.formatMessage(messages.placeholder)}
                          required
                        />
                      </FormItem>
                    )}
                  </Fieldset>
                  <FormActions>
                    {!this.props.commandResponse ? (
                      <React.Fragment>
                        <Button
                          type="submit"
                          appearance="primary"
                          state={
                            this.props.commandPending
                              ? "pending"
                              : !this.state.allowSubmit
                              ? "disabled"
                              : undefined
                          }
                          onDisableClick={() => {}}
                        >
                          {intl.formatMessage(messages.submit)}
                        </Button>
                        <Divider />
                        <ButtonLink to="/login" buttonAppearance="default">
                          {intl.formatMessage(messages.backLogin)}
                        </ButtonLink>
                      </React.Fragment>
                    ) : (
                      <ButtonLink to="/" buttonAppearance="default">
                        {intl.formatMessage(messages.back)}
                      </ButtonLink>
                    )}
                  </FormActions>
                </Form>
              </div>
            </div>
          </div>
          {this.props.backgroundImage && (
            <ResizedImage
              className="account-form--register__image"
              src={this.props.backgroundImage}
              alt="login background"
              format="backgroundForm"
              cover
            />
          )}
        </div>
        <Reassurance big />
      </React.Fragment>
    );
  }
}

export default EnhancePasswordRequest({
  PasswordRequestConfigurationQuery,
  PasswordRequestMutation: InitiatePasswordReset,
})(injectIntl(PasswordRequest));
